import NBTrpc from '@tencent/nb-trpc';
import JsBridge from '@/utils/jsBridge';
// import Perf from './performance';
// import Logger from './logger';
// import Url from './url';
import { ENV_ENUM, curEnv } from '@tencent/nb-h5-tools';

const isApp = curEnv === ENV_ENUM.APP_ANDROID || curEnv === ENV_ENUM.APP_IOS;
// 超时时长
const TIMEOUT = 8000;

const TRPCConfig = {
  version: 1,
  serverUrl: process.env.SERVER_PREFIX,
  biz: 'YZ',
  header: {
    Utype: 2,
  },
  withCredentials: true,
  timeout: TIMEOUT,
  // sucLogCallback: (payload) => {
  //   const page = Url.getPage();
  //   const { args } = payload;
  //   Logger.uplog('INFO', 'request success', {
  //     ...payload,
  //     page,
  //     args: {
  //       ...args,
  //       Page: page,
  //     },
  //   });
  // },
  // errLogCallback: (errLevel, payload) => {
  //   const page = Url.getPage();
  //   let level = errLevel;
  //   let errMsg = 'request fail';
  //   // 当请求错误原因是超时, 上报改为 WARN
  //   if (payload.total > (TIMEOUT - 100)) {
  //     level = 'WARN';
  //     errMsg = 'request timeout';
  //   }
  //   const { args } = payload;
  //   Logger.uplogNow(level, errMsg, {
  //     ...payload,
  //     page,
  //     args: {
  //       ...args,
  //       Page: page,
  //       cookie: document.cookie,
  //       ua: navigator.userAgent,
  //       perf: JSON.stringify(window.performance || {}),
  //     },
  //   });
  // },
};

const TRPC = {};

TRPC.newRequest = async function (path, data) {
  await injectDUA();
  // 通知已经开始请求
  // Perf.fireRequestStart();
  return new Promise((resolve, reject) => {
    NBTrpc.newRequest(path, data, TRPCConfig)
      .then((res) => {
        const result = JSON.parse(res.data);
        // TODO:fix 传入更多信息
        resolve(result);
      })
      .catch((errTrpc) => {
        console.log('err ', JSON.stringify(errTrpc));
        reject(errTrpc);
      });
  });
};

// 注入 DUA
async function injectDUA() {
  // dua 已存在, 直接返回
  if (TRPCConfig.dua) {
    return;
  }
  // JSBridge 不存在, 返回默认 DUA
  if (
    !isApp
    || !JsBridge
    || !JsBridge.Ares) {
    TRPCConfig.dua = 'DV=1&PL=Web&APPOS=h5';
    return;
  }
  try {
    // 有 getDUA 函数, 则直接获取
    const canUseGetDua = await JsBridge.Ares.canIUse('getDua');
    if (canUseGetDua && canUseGetDua.code === 0 && !canUseGetDua.error) {
      console.log('通过 getDua 获取 DUA');
      const res = await JsBridge.Ares.getDua();
      TRPCConfig.dua = res.dua;
    } else {
      console.log('自主拼接 DUA');
      // 没有 getDUA 函数, 则主动拼接
      const platform = await JsBridge.Ares.getPlatform().catch(e => console.log(e));
      const version = await JsBridge.Ares.getAppVersion().catch(e => console.log(e));
      const channel = await JsBridge.Ares.getChannelId().catch(e => console.log(e));
      // PL表征平台; APPOS是它的补充字段
      TRPCConfig.dua = `DV=${TRPCConfig.version || 1}&PL=Web&APPOS=${platform || 'h5'}&PPVN=${version || ''}&CHID=${channel || ''}`;
    }
  } catch (err) {
    console.log('JsBridge.Ares ->', err);
  }
}

export default TRPC;
